module.exports = __webpack_public_path__ + "media/images/SkateboardWithSpeechBubble-2bcdac4f.svg";